module.exports = __webpack_public_path__ + "static/il-coin-0999e2019bba7cfe95ac9b7f346fecd8.svg";